import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const TravelIcon = ({ width, height, color }: IProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width ?? 24}
            height={height ?? 24}
            viewBox='0 0 24 24'
            fill='none'
        >
            <path
                d='M12.0004 1.6001C11.1164 1.6001 10.4004 2.3161 10.4004 3.2001V9.38135L2.40039 15.2001V16.8001L10.4004 14.6188V19.6798L7.20039 21.6001V22.4001H11.2004H13.6004H16.8004V21.6001L13.6004 19.6798V14.6188L21.6004 16.8001V15.2001L13.6004 9.38135V3.2001C13.6004 2.3161 12.8844 1.6001 12.0004 1.6001Z'
                fill={color ?? colors.grey[50]}
            />
        </svg>
    )
}

export default React.memo(TravelIcon)
